import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "@/functions/filters";
import "./registerServiceWorker";

import VueOffline from "vue-offline";

Vue.config.productionTip = process.env.VUE_APP_PRODUCTION_TIP;
Vue.config.ignoredElements = ["space", "code"];

Vue.use(VueOffline);

new Vue({
  router,
  store,
  mounted() {},
  render: h => h(App)
}).$mount("#app");

// Custom filters
Vue.filter("truncate", function(text, length, suffix) {
  if (text.length > length) {
    const wordEnd = text.indexOf(" ", length);
    if (wordEnd == -1) {
      return text;
    } else {
      return text.substring(0, wordEnd) + suffix;
    }
  } else {
    return text;
  }
});
